import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { User } from '@/types';
import * as api from './api';

export function useUsers(enabled = true) {
  return useQuery<User[]>({ queryKey: ['users'], queryFn: api.fetchUsers, enabled });
}

function useInvalidateUsers() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: ['users'] });
    void queryClient.invalidateQueries({ queryKey: ['app', 'equipa'] });
    void queryClient.invalidateQueries({ queryKey: ['partes'] });
    void queryClient.invalidateQueries({ queryKey: ['mapas'] });
  };
}

export function useCreateUser() {
  const invalidate = useInvalidateUsers();
  return useMutation({ mutationFn: api.createUser, onSuccess: invalidate });
}

export function useUpdateUser() {
  const invalidate = useInvalidateUsers();
  return useMutation({
    mutationFn: ({ id, ...input }: { id: string } & api.UpdateUserInput) =>
      api.updateUser(id, input),
    onSuccess: invalidate,
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: ({ id, newPassword }: { id: string; newPassword?: string }) =>
      api.resetPassword(id, newPassword),
  });
}

export function useDeleteUser() {
  const invalidate = useInvalidateUsers();
  return useMutation({ mutationFn: api.deleteUser, onSuccess: invalidate });
}
